import { ScrollView } from 'react-native';

import NotionDatabase from '@/src/components/dev/notion-database';

export default function Examples() {
  return (
    <ScrollView>
      <h1>Examples</h1>
      <p>
        This page renders content from a Notion page alongside components in the
        codebase. The idea is that we can render many constructs used in the
        product development cycle in one place. This &apos;neutral&apos; source
        of truth allows us to see different aspects of a feature in one place.
      </p>
      <h2>Notion Databases</h2>
      <p>We can render a list of examples stored in a Notion databases</p>
      <NotionDatabase databaseId='8c4fe0fab8f34935930d914dbff0ae7a' />
    </ScrollView>
  );
}
